export const CART_HINT_SNACKBAR_VARIANT = {
  FLOATING: 'floating',
  BANNER: 'banner'
} as const;
